<select [ngModel]="value" (ngModelChange)="changeValue($event)">
    <option value="Arial">Arial</option>
    <option value="Arial Black">Arial Black</option>
    <option value="Comic Sans MS">Comic Sans MS</option>
    <option value="Courier New">Courier New</option>
    <option value="Narrow">Narrow</option>
    <option value="Garamond">Garamond</option>
    <option value="Georgia">Georgia</option>
    <option value="Impact">Impact</option>
    <option value="Sans Serif">Sans Serif</option>
    <option value="Serif">Serif</option>
    <option value="Tahoma">Tahoma</option>
    <option value="Trebuchet MS">Trebuchet MS</option>
    <option value="Verdana">Verdana</option>
</select>